module.exports = ($scope, $upload, $uibModalInstance, endpoints, file, mappingId, mappingName) ->

  $scope.filename = file.name
  $scope.mappingName = mappingName

  $scope.upload = () ->
    $upload.upload
      url: endpoints.BulkUpload
      data:
        file: file
        mapping: mappingId
    .success () ->
      $uibModalInstance.close()

  $scope.cancel = ->
    $uibModalInstance.close()
    return
